import * as React from 'react';
import { makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        appBar: {
            position: 'relative'
        },
        layout: (_a = {
                width: 'auto',
                height: '100%',
                marginTop: theme.spacing(3),
                marginLeft: theme.spacing(2),
                marginRight: theme.spacing(2)
            },
            _a[theme.breakpoints.up(1024 + theme.spacing(2) * 2)] = {
                width: 1024,
                marginLeft: 'auto',
                marginRight: 'auto'
            },
            _a)
    });
});
export var CenterLayout = function (_a) {
    var children = _a.children;
    var classes = useStyles();
    return React.createElement("main", { className: classes.layout }, children);
};
//# sourceMappingURL=center-layout.js.map